// @flow

import * as ReduxActions     from 'redux-actions';
import type { Action }       from '../../../redux/redux.types';
import type { SyncedAction } from '../../domain/syncActions.types';


// -----------------------------------------------------------------------------------------------------------------
// Types
// -----------------------------------------------------------------------------------------------------------------

type ImportSyncedActionType = 'SYNC_ACTIONS:IMPORT';

export type ImportSyncedActionArgs = {|
  action: SyncedAction,
|};

type ImportSyncedActionPayload = {|
  action: $PropertyType<ImportSyncedActionArgs, 'action'>,
|};

export type ImportSyncedAction = Action<ImportSyncedActionType, ImportSyncedActionPayload>;

const importSyncedAction = ReduxActions.createAction(
  'SYNC_ACTIONS:IMPORT',
  ({action}: ImportSyncedActionArgs): ImportSyncedActionPayload => ({action}),
);


export default importSyncedAction;



// WEBPACK FOOTER //
// ./src/modules/actionSync/store/actions/importSyncedAction.js